import { Box, useTheme } from "@mui/material"
import { LoginBackground } from "./LoginBackground";
import { LoginForm } from "./LoginForm";

export const LoginPage = () => {

  const theme = useTheme();
  const version = import.meta.env.VITE_REACT_APP_VERSION;

  return (
    <LoginBackground>
      <title>Racing Pricing Manager</title>
      <LoginForm />
      <Box sx={{ position: 'absolute', marginLeft: 'auto', width: '100vw', left: 0, bottom: '40px' }}>
        Version:&nbsp; <span style={{ color: theme.palette.primary.light }}>{version}</span>
      </Box>
    </LoginBackground>
  )
}
